module.exports = __webpack_public_path__ + "static/media/Omnivati-logo.2ea689f5.svg";